import { useEffect } from 'react';
import { useUpdateEffect } from 'react-use';

import { useTranslation } from '@lyearn/i18n';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

import { validateQuizQuestion } from '../../utils/validations';
import useQuizEditorState from '../useQuizEditorState';

interface Params {
  state: ReturnType<typeof useQuizEditorState>;
  isQuizPublished: Boolean;
}

const useQuizEditorEffects = ({ isQuizPublished, state }: Params) => {
  const { uiState, questions, setUiState } = state;

  const { t } = useTranslation();

  const { [FeatureFlags.EnableSubWorkspacesForQuestions]: isQuestionSubWorkspacesEnabled } =
    useFeatureFlags();

  useEffect(() => {
    if (isQuizPublished && uiState.showLimitingEditingModal !== false) {
      setUiState({ showLimitingEditingModal: true });
    }
  }, [isQuizPublished, setUiState, uiState.showLimitingEditingModal]);

  useUpdateEffect(() => {
    const question = questions[uiState.selectedQuestionIndex];
    if (!question) {
      return;
    }

    const prevError = uiState.errors[question.id];

    if (!prevError) {
      return;
    }

    const nextError = validateQuizQuestion({ t, question, isQuestionSubWorkspacesEnabled });
    setUiState({
      errors: {
        ...uiState.errors,
        [question.id]: prevError.type === nextError?.type ? nextError : undefined,
      },
    });
  }, [questions]);
};

export default useQuizEditorEffects;
